import { Plugin } from 'ckeditor5';

export default class CustomImageSizeMaxValueReset extends Plugin {
	static get pluginName() { return "CustomImageSizeMaxValueReset" }

	init() {
		const editor = this.editor;

		if (editor.plugins.has('ContextualBalloon') && editor.plugins.has('ImageCustomResizeUI')) {
			let customImageSizePlugin = editor.plugins.get('ContextualBalloon');

			customImageSizePlugin.on('change:visibleView', (eventInfo, eventName, newView, oldView) => {
				if (this._isCustomImageResizeBalloon(newView)) {
					// set step to 1 to avoid decimal pixels
					newView.template.children[0].fieldView.set({ step: 1 });

					newView.template.children[0].fieldView.once('set:min', (eventInfo) => {
						// set min width to 1 to avoid decimal pixels
						eventInfo.return = 1;
					});

					newView.template.children[0].fieldView.once('set:max', (eventInfo) => {
						// set max width to configured max width (or null if not configured)
						eventInfo.return = editor.config.get('image.resizeMaxWidth') || null;
					});

					newView.template.children[0].fieldView.once('set:value', (eventInfo, eventName, newValue, oldValue) => {
						// remove decimals from new value
						eventInfo.return = parseFloat(newValue).toFixed(0);
					});
				}
			});
		}
	}

	_isCustomImageResizeBalloon(balloonView) {
		if (balloonView && balloonView.template && balloonView.template.attributes && balloonView.template.attributes.class) {
			return balloonView.template.attributes.class.indexOf('ck-image-custom-resize-form') >= 0;
		}

		return false;
	}
}